// extracted by mini-css-extract-plugin
export default {"container":"CfnMli","text":"jIIwAR","link":"HuloP0","button":"q00Cev"};